import { Box, IconButton, Typography, styled, useTheme } from "@mui/material";

import QRCode from "qrcode.react";
import useNotify from "hooks/useNotify";

function QrCode({ value, text, alertText }) {
  const theme = useTheme()
  const notify = useNotify();

  const copyTextToValue = () => {
    navigator.clipboard.writeText(text);

    notify(alertText || "کد با موفقیت کپی شد", "success");
  };

  return (
    <QrCodeWrapper>
      <QRCode value={value.toString().trim()} />

      <QrCodeTextWrapper>
        <Typography variant="h6" color="text.main">
          {text}
        </Typography>

        <IconButton onClick={copyTextToValue} size="small" color={theme.mode === "info" || theme.mode === "tertiary" ?  "primary" : "text"}>
          <ion-icon name="copy"></ion-icon>
        </IconButton>
      </QrCodeTextWrapper>
    </QrCodeWrapper>
  );
}

const QrCodeWrapper = styled(Box)(({ theme }) => ({
  textAlign: "center",
  flexDirection: "column",
  width: "100%",
  canvas: {
    background: theme.palette.common.white,
    padding: theme.spacing(1),
    width: "180px !important",
    height: "180px !important",
  },
}));

const QrCodeTextWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "left",
  flexDirection: "row-reverse",
}));

export default QrCode;
